import React, { FC } from 'react';
import { AvailablePopups } from 'store/app/types';
import Popup from 'components/Common/Popup/Popup';
import { useDispatch, useSelector } from 'react-redux';

import StudioBundleProducts from 'components/StudioSearchProductPage/StudioBundleProducts/StudioBundleProducts';
import getCurrentProduct from 'store/publicAssetProduct/selector/getCurrentProduct';
import getSelectedAbstractProduct from 'store/publicAssetProduct/selector/getSelectedAbstractProduct';
import getProductId from 'store/publicAssetProduct/selector/getProductId';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmChangeAttributeEvent from 'utils/gtm/gtmChangeAttributeEvent';
import changeAttributeOperation from 'store/publicAssetProduct/operation/changeAttributeOperation';
import StudioProductAttributes from '../../StudioSearchProductPage/StudioProductAttributes/StudioProductAttributes';
import styles from './AttributeSelectionMobilePopup.module.scss';
import StudioProductPrice from '../../StudioSearchProductPage/StudioProductPrice/ProductPrice';

const AttributeSelectionMobilePopup: FC = ({ children }) => {
  const productId = useSelector(getProductId);
  const selectedAbstractProduct = useSelector(getSelectedAbstractProduct);
  const dispatch = useDispatch();

  const currentProduct = useSelector(getCurrentProduct);

  const getAbstractProductSelectors = () => {
    return selectedAbstractProduct?.productPageSelectors || [];
  };

  const getCurrentProductAttributes = () => {
    return currentProduct?.attributes || [];
  };

  const changeAttribute = (typeName: string, value: string, defaultProductId: number) => {
    gtmSendEvent(gtmChangeAttributeEvent(typeName, value));
    dispatch(changeAttributeOperation(typeName, value, defaultProductId));
  };

  return (
    <Popup
      popupId={AvailablePopups.attributeSelectionMobilePopup}
      wrapperClassName={styles.popupWrapper}
      contentClassName={styles.popupContent}
      closeIconInContent
    >
      <div className={styles.attributeSelectionMobilePopup}>
        <StudioProductAttributes
          studioProductPageSelectors={getAbstractProductSelectors()}
          currentProductAttributes={getCurrentProductAttributes()}
          currentProductItem={currentProduct}
          allProducts={selectedAbstractProduct?.products || []}
          changeAttribute={changeAttribute}
          productId={productId || 1}
        />
        <StudioBundleProducts abstractProduct={selectedAbstractProduct} productId={currentProduct?.productId || 1} />
        <StudioProductPrice
          categoryId={currentProduct?.categoryId || 1}
          productId={currentProduct?.productId || 1}
          quantity={1}
          inOneLine
        />
        {children}
      </div>
    </Popup>
  );
};

export default AttributeSelectionMobilePopup;
